var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal-window',{ref:"modal",staticClass:"modal-notification",attrs:{"width":600,"height":400,"title":_vm.title}},[_c('div',{staticClass:"modal-notification__inner",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }